import React from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { ServicesSection } from './components/ServicesSection';
import { PortfolioSection } from './components/PortfolioSection';
import { Footer } from './components/Footer';
import { FloatingWhatsApp } from './components/FloatingWhatsApp';
export function App() {
  return <div className="min-h-screen bg-dark-900 text-white font-sans selection:bg-gold/30 selection:text-gold-light" data-id="element-0">
      <Navbar data-id="element-1" />

      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <ServicesSection data-id="element-4" />
        <PortfolioSection data-id="element-5" />
      </main>

      <Footer data-id="element-6" />
      <FloatingWhatsApp data-id="element-7" />
    </div>;
}